import { IconProps, iconColor } from './IconProps'

import styles from './Icons.module.scss'

export function CheckBoxIcon(props: IconProps): JSX.Element {
  const size = props.size || 24

  return (
    <svg {...props} width={size} height={size} viewBox='0 0 24 24' fill='none'>
      <path
        d='M18.5 8.4L17.1 7L10.5 13.6L6.9 10L5.5 11.4L9.1 15L10.5 16.4L11.9 15L18.5 8.4Z'
        fill={props.color ? styles[props.color] : iconColor(props)}
      />
    </svg>
  )
}
